import { createContext, use, useReducer } from 'react';
import { get } from 'api';
// import { eventList, taskList } from 'data/calendar';
import { SET_CALENDAR_STATE, calendarReducer } from 'reducers/CalendarReducer';

export const CalendarContext = createContext({});

const CalendarProvider = ({ children }) => {
  const fetchHolidays = async () => {
    try {
      const res = await get('/users/holidays'); // your API endpoint

      // ⚡ Important: format data for FullCalendar
      if (res.status == 200) {
        const formattedHolidays = res.data.map((holiday) => ({
          id: holiday._id,
          title: holiday.name,
          start: holiday.date,
          end: holiday?.toDate || null,
          category: holiday.type,
          allDay: true,
          backgroundColor: '#ff4d4f', // optional styling
          borderColor: '#ff4d4f',
          editable: false,
        }));
        calendarDispatch({
          type: SET_CALENDAR_STATE,
          payload: { events: formattedHolidays },
        });
      }
    } catch (error) {
      console.error('Failed to fetch holidays', error);
    }
  };

  const initialState = {
    calendarApi: null,
    schedulerApi: null,
    title: '',
    selectedItem: null,
    view: 'dayGridMonth',
    openNewEventModal: false,
    selectedStartDate: '',
    selectedEndDate: '',
    events: [],
    tasks: [],
  };

  const [calendarState, calendarDispatch] = useReducer(calendarReducer, initialState);

  const updateView = (type, action) => {
    const api = type === 'calendar' ? calendarState.calendarApi : calendarState.schedulerApi;
    if (!api) return;
    if (action === 'next') api.next();
    else if (action === 'prev') api.prev();
    else api.today();

    calendarDispatch({
      type: SET_CALENDAR_STATE,
      payload: { title: api.view.title },
    });
  };

  const navigateToDate = (date) => {
    if (calendarState.calendarApi) {
      calendarState.calendarApi.gotoDate(date);
    }
  };

  return (
    <CalendarContext
      value={{
        ...calendarState,
        calendarDispatch,
        updateView,
        navigateToDate,
        fetchHolidays,
      }}
    >
      {children}
    </CalendarContext>
  );
};

export const useCalendarContext = () => use(CalendarContext);

export default CalendarProvider;
